export function TickMarkBlue({ color = "#784EFF" }) {
  return (
    <svg width={11} height={10} fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.262 1.162 3.3 6.925l-1.575-1.7a.875.875 0 0 0-1.088-.05.762.762 0 0 0-.225 1l1.875 3.062c.188.275.513.45.863.45s.662-.175.85-.45c.3-.387 6.025-7.225 6.025-7.225.75-.75-.163-1.437-.75-.85h-.013Z"
        fill={color}
      />
    </svg>
  );
}
